/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_appsync_graphqlEndpoint": "https://qa5bcbrhabg35iu7hff6zooccq.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-hlzzcwv3qncefn5ytdk7opzyce",
    "aws_cloud_logic_custom": [
        {
            "name": "middlewareREST",
            "endpoint": "https://kkkl4mfbl1.execute-api.eu-central-1.amazonaws.com/uat",
            "region": "eu-central-1"
        },
        {
            "name": "notificationsApi",
            "endpoint": "https://uwfkqogx9g.execute-api.eu-central-1.amazonaws.com/uat",
            "region": "eu-central-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-central-1:e9d3ac21-ae97-4c84-9156-7da0a835c1f8",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_74Tzq9nLa",
    "aws_user_pools_web_client_id": "36844ms2ddmdjq44np2bojt4qo",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "labouronnect-20200228115848-hostingbucket-uat",
    "aws_content_delivery_bucket_region": "eu-central-1",
    "aws_content_delivery_url": "http://labouronnect-20200228115848-hostingbucket-uat.s3-website.eu-central-1.amazonaws.com",
    "aws_user_files_s3_bucket": "labourtech-case-documents103623-uat",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
